var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconVisualizarDiscussaoCaso = function SvgIconVisualizarDiscussaoCaso(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4L2 16.7965L5 13.7143L8.11782 13.7143C8.24965 13.0042 8.48868 12.3317 8.81749 11.7143L5 11.7143C4.64573 11.7143 4.30133 11.8083 4 11.9822L4 4L14 4L14 8.07089C14.3266 8.02417 14.6605 8 15 8C15.3395 8 15.6734 8.02417 16 8.07089L16 4C16 2.89543 15.1046 2 14 2L4 2C2.89543 2 2 2.89543 2 4Z",
    fill: "#3A3A47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C12 8.55228 11.5523 9 11 9C10.4477 9 10 8.55228 10 8C10 7.44771 10.4477 7 11 7C11.5523 7 12 7.44771 12 8Z",
    fill: "#3A3A47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8 8.55228 7.55229 9 7 9C6.44772 9 6 8.55228 6 8C6 7.44771 6.44772 7 7 7C7.55229 7 8 7.44771 8 8Z",
    fill: "#3A3A47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10C17.7614 10 20 12.2386 20 15C20 16.0147 19.6977 16.9588 19.1784 17.7472L19.2734 17.8426C19.7389 18.3099 21.7558 20.3352 21.7558 20.3352C22.1487 20.782 21.9991 21.3484 21.6689 21.6769C21.3388 22.0053 20.7728 22.146 20.3528 21.7309L20.3094 21.6876C19.9717 21.3504 17.7766 19.1588 17.7766 19.1588C16.9823 19.6902 16.0274 20 15 20C12.2386 20 10 17.7614 10 15C10 12.2386 12.2386 10 15 10ZM15 12C13.3431 12 12 13.3431 12 15C12 16.6569 13.3432 18 15 18C16.6569 18 18 16.6569 18 15C18 13.3431 16.6569 12 15 12Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVisualizarDiscussaoCaso, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-visualizar-discussao-caso.2fe32fcb.svg";
export { ForwardRef as ReactComponent };